import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

// 18/10/2026: pop-up ao tocar em PGT. / +60D no topo (prévia aprovada:
// https://claude.ai/artifact/EBaiXnV6xtHdD3eRKn75vb). Dados vêm do próprio
// monitor (data.detalhe), calculados no servidor junto com os totais.
const GREEN = "#8FE9BE";
const RED = "#FFA79B";
const MONO = "'IBM Plex Mono', ui-monospace, monospace";

const fmt = (n) => Number(n || 0).toLocaleString("pt-BR");

const Row = ({ dot, title, sub, value, color }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 14px", borderRadius: 12, background: "#182a27" }}>
    <span style={{ width: 12, height: 12, borderRadius: "50%", background: dot, flexShrink: 0 }} />
    <div style={{ flex: 1, minWidth: 0 }}>
      <div style={{ fontWeight: 700, fontSize: 15 }}>{title}</div>
      {sub ? <div style={{ fontSize: 12, color: "#9fb1ab", marginTop: 2 }}>{sub}</div> : null}
    </div>
    <span style={{ fontFamily: MONO, fontSize: 20, fontWeight: 700, color }}>{fmt(value)}</span>
  </div>
);

const FichasMonitorDialog = ({ open, kind, data, onClose, onOpenFicha }) => {
  const [openFaixa, setOpenFaixa] = useState(null);
  useEffect(() => { if (!open) setOpenFaixa(null); }, [open]);
  const det = data?.detalhe || null;
  const isPgt = kind === "pgt";

  const header = (label, total, color) => (
    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: ".08em", color }}>{label}</div>
        <div style={{ fontFamily: MONO, fontSize: 30, fontWeight: 700, color: "#fff" }}>{fmt(total)}</div>
      </div>
      <IconButton size="small" onClick={onClose} aria-label="Fechar" style={{ background: "rgba(255,255,255,0.08)", color: "#d6e2de" }}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </div>
  );

  let body = null;
  if (!det) {
    body = <div style={{ color: "#9fb1ab", fontSize: 14 }}>Calculando os números… abra de novo em alguns segundos.</div>;
  } else if (isPgt) {
    const total = Math.max(1, Number(data.pagantes || 0));
    const pct = (n) => `${(Number(n || 0) / total) * 100}%`;
    const detalheEmDia = Object.entries(det.emDiaPorStatus || {})
      .sort((a, b) => b[1] - a[1])
      .map(([k, v]) => `${k} ${fmt(v)}`)
      .join(" · ");
    body = (
      <>
        <div style={{ height: 10, borderRadius: 6, overflow: "hidden", display: "flex", background: "#1e302d" }}>
          <div style={{ width: pct(det.emDia), background: "#2fbf71" }} />
          <div style={{ width: pct(det.falta), background: "#e6c02e" }} />
          <div style={{ width: pct(det.devendo), background: "#e8604c" }} />
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <Row dot="#2fbf71" title="Em dia" sub={detalheEmDia} value={det.emDia} color={GREEN} />
          <Row dot="#e6c02e" title="Falta" sub="Pagou só uma parte do mês" value={det.falta} color="#f2d76b" />
          <Row dot="#e8604c" title="Devendo" sub="Até 59 dias de atraso (60+ fica no +60D)" value={det.devendo} color={RED} />
        </div>
      </>
    );
  } else {
    const faixas = det.faixas60 || [];
    const max = Math.max(1, ...faixas.map((f) => f.count || 0));
    body = (
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {faixas.map((f) => {
          const aberta = openFaixa === f.label;
          return (
            <div key={f.label} style={{ borderRadius: 12, background: "#2b1c1b", overflow: "hidden" }}>
              <button
                type="button"
                onClick={() => setOpenFaixa(aberta ? null : f.label)}
                disabled={!f.count}
                style={{
                  width: "100%", display: "grid", gridTemplateColumns: "96px minmax(0,1fr) 48px 20px",
                  alignItems: "center", gap: 12, padding: "10px 14px", background: "none", border: "none",
                  color: "inherit", cursor: f.count ? "pointer" : "default", fontFamily: "inherit", textAlign: "left"
                }}
              >
                <span style={{ fontWeight: 700, fontSize: 15 }}>{f.label}</span>
                <span style={{ height: 8, borderRadius: 5, background: "#3a2625", overflow: "hidden" }}>
                  <span style={{ display: "block", height: "100%", borderRadius: 5, background: "#e8604c", width: `${((f.count || 0) / max) * 100}%` }} />
                </span>
                <span style={{ fontFamily: MONO, fontSize: 18, fontWeight: 700, color: RED, textAlign: "right" }}>{fmt(f.count)}</span>
                <ExpandMoreIcon style={{ fontSize: 18, opacity: f.count ? 0.7 : 0.2, transform: aberta ? "rotate(180deg)" : "none", transition: "transform .15s" }} />
              </button>
              {aberta ? (
                <div style={{ maxHeight: 260, overflowY: "auto", borderTop: "1px solid #3a2625" }}>
                  {(f.clientes || []).map((c) => (
                    <button
                      key={`${c.r}-${c.c}`}
                      type="button"
                      onClick={() => onOpenFicha && onOpenFicha(c)}
                      style={{
                        width: "100%", display: "flex", alignItems: "center", gap: 10, padding: "9px 14px",
                        background: "none", border: "none", borderBottom: "1px solid rgba(255,255,255,0.04)",
                        color: "inherit", cursor: "pointer", fontFamily: "inherit", textAlign: "left"
                      }}
                    >
                      <span style={{ flex: 1, minWidth: 0 }}>
                        <span style={{ display: "block", fontSize: 14, fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{c.n}</span>
                        {c.cid ? <span style={{ display: "block", fontSize: 11, color: "#b79d9a" }}>{c.cid}</span> : null}
                      </span>
                      <span style={{ fontFamily: MONO, fontSize: 13, fontWeight: 700, color: RED }}>{fmt(c.d)} dias</span>
                    </button>
                  ))}
                </div>
              ) : null}
            </div>
          );
        })}
        <div style={{ fontSize: 12, color: "#b79d9a", marginTop: 4 }}>Toque numa faixa pra ver os clientes; toque no cliente pra abrir a ficha.</div>
      </div>
    );
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          width: 440, maxWidth: "calc(100vw - 32px)", borderRadius: 18, padding: 22,
          background: isPgt ? "#13211f" : "#221615", border: `1px solid ${isPgt ? "#24403a" : "#47292a"}`,
          color: "#e7efec", display: "flex", flexDirection: "column", gap: 16, alignSelf: "flex-start", marginTop: 80
        }
      }}
      BackdropProps={{ style: { background: "rgba(3,8,10,0.72)" } }}
    >
      {isPgt
        ? header("PAGANTES", data?.pagantes, GREEN)
        : header("DEVENDO HÁ MAIS DE 60 DIAS", data?.atraso60, RED)}
      {body}
    </Dialog>
  );
};

export default FichasMonitorDialog;
